import {
  ActionIcon,
  Avatar,
  Badge,
  Group,
  Paper,
  Text,
  Tooltip,
} from "@mantine/core";
import { IconBrush, IconEdit, IconTrash } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { useDeleteEvent } from "../../api/event";
import classes from "./WorkspaceDashboard.module.css";
import { useDeleteConfirm } from "../../hooks/useDeleteConfirm";

export function EventItem({ event, isActive, onSelect, statusColor, isAdmin }) {
  const navigate = useNavigate();
  const { mutate: deleteEvent } = useDeleteEvent();
  const confirmDelete = useDeleteConfirm("event", deleteEvent);

  return (
    <Paper
      key={event.id}
      className={`${classes.eventItem} ${isActive ? classes.activeEvent : ""}`}
      onClick={() => onSelect(event)}
    >
      <Group gap="md">
        <Avatar
          src={event?.config?.logoImage}
          radius="sm"
          size="md"
          color={event?.config?.accentColor || "blue"}
        >
          {event.name?.[0]}
        </Avatar>
        <div>
          <Text fw={600} size="sm">
            {event.name}
          </Text>
          <Badge size="md" color={statusColor(event.status)} variant="dot">
            {event.status}
          </Badge>
        </div>
      </Group>

      <Group gap="xs">
        <Tooltip label="Customize UI">
          <ActionIcon
            variant="light"
            color="green"
            size="md"
            onClick={(e) => {
              e.stopPropagation();
              onSelect(event);
              navigate("/app/events/customize");
            }}
          >
            <IconBrush size={24} />
          </ActionIcon>
        </Tooltip>
        {isAdmin && (
          <Tooltip label="Edit Details">
            <ActionIcon
              variant="light"
              color="blue"
              size="md"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/app/events/${event.id}`);
              }}
            >
              <IconEdit size={24} />
            </ActionIcon>
          </Tooltip>
        )}
        {isAdmin && (
          <Tooltip label="Delete Event">
            <ActionIcon
              variant="light"
              color="red"
              size="md"
              onClick={(e) => {
                e.stopPropagation();
                confirmDelete({ id: event.id });
              }}
            >
              <IconTrash size={24} />
            </ActionIcon>
          </Tooltip>
        )}
      </Group>
    </Paper>
  );
}
